<template>
  <v-tooltip
    :location="tooltipLocation"
    :disabled="isDisabled"
    :max-width="maxWidth"
    content-class="text-primary border tooltip-styling"
  >
    <template #activator="data">
      <slot name="activator" v-bind="data" />
    </template>

    <div
      class="whitespace-pre-wrap text-black"
      :class="{
        'text-center': position === 'top' || position === 'bottom',
        'text-right': position === 'left',
      }"
    >
      <slot />
    </div>
  </v-tooltip>
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core';
import { computed } from 'vue';

import type { ITooltipProps } from './tooltip-types';

const props = withDefaults(defineProps<ITooltipProps>(), {
  disabled: false,
  position: 'top',
  maxWidth: undefined,
});

// On touch devices a tap fires synthetic hover/focus that opens the tooltip and
// leaves it stuck, so disable it there entirely.
const isTouchDevice = useMediaQuery('(hover: none)');
const isDisabled = computed(() => props.disabled || isTouchDevice.value);

const tooltipLocation = computed(() => {
  if (props.position === 'left') return 'start';
  if (props.position === 'right') return 'end';
  return props.position;
});
</script>

<style lang="scss">
.hover:hover {
  cursor: help;
}

.tooltip-styling {
  border: 1px solid theme('colors.grey.200');
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 8%) 0 4px 12px 0;
  background-color: theme('colors.app.white');
}
</style>
